import { Component } from '@angular/core';


@Component({
  standalone: false,
  selector: 'bt-user',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss']
})

export class CompanyComponent {

}
